import React from 'react'
import PropTypes from 'prop-types'
import Media from 'sb-media'
import { links } from 'common/helpers'
import { FormattedMessage, FormattedHTMLMessage } from 'sb-react-intl'

import MainSection from 'components/layout/MainSection/MainSection'
import WidthContainer from 'components/layout/WidthContainer/WidthContainer'
import Picture from 'components/ui/Picture/Picture'
import Button from 'components/buttons/Button/Button'

import messages from './messages'
import s from './404.scss'

// resolve picture x2 x3
import mobileImage from './images/mobile-404.jpg'
import desktopImage from './images/desktop-404.svg'


const Page404 = ({ err }) => (
  <WidthContainer>
    <MainSection>
      <div className={s.content}>
        <Media mobile>
          {
            (isMobile) => isMobile ? (
              <Picture className={s.image} {...mobileImage} alt="404 Not found" />
            ) : (
              <img className={s.image} src={desktopImage} alt="404 Not found" />
            )
          }
        </Media>
        <div className={s.info}>
          <FormattedMessage className={s.title} tag="div" {...messages.title} />
          <FormattedHTMLMessage className={s.desc} tag="div" {...messages.desc} />
          <Button className={s.button} brand title={messages.buttonTitle} toOLD={links.home} />
        </div>
      </div>
      <div style={{ display: 'none' }} id="404-errorText" dangerouslySetInnerHTML={{ __html: err || 'Error: unknown' }} />
    </MainSection>
  </WidthContainer>
)

Page404.propTypes = {
  err: PropTypes.string,
}


export default Page404
